import React, { useState } from 'react'
import { useTheme, Tooltip, Switch, Slider, IconButton } from '@mui/material'
import { Casino as CasinoIcon, SelectAll as SelectAllICon } from '@mui/icons-material'
import { common as commonColors } from '@mui/material/colors'

export default function SlideFeaturesFiltersSwitch(props) {
  const theme = useTheme()
  const [value, setValue] = useState([props.slideFeatureFilter.min, props.slideFeatureFilter.max])

  const handleSliderChange = (event, newValue) => {
    setValue(newValue)
  }

  React.useEffect(() => {
    setValue([props.slideFeatureFilter.min, props.slideFeatureFilter.max])
  }, [props.slideFeatureFilter.min, props.slideFeatureFilter.max])

  return (
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <Tooltip title={(props.activeFeatureFilters[props.slideFeatureFilter.name] ? 'Hide ': 'Show ') + props.slideFeatureFilter.name} placement="right">
        <span>
          <Switch checked={props.activeFeatureFilters[props.slideFeatureFilter.name]}
          onChange={props.activeFeatureFiltersChanged}
          name={props.slideFeatureFilter.name}/>
        </span>
      </Tooltip>
      <span style={{marginRight: '20px'}}>
        {props.slideFeatureFilter.name + ' (' + props.assetsNumber + ')'}
      </span>
      { props.slideFeatureFilter.type === 'float' &&
        <Slider
          style={{marginTop: '20px'}}
          value={value}
          min={props.slideFeatureFilter.marks[0].value}
          max={props.slideFeatureFilter.marks[props.slideFeatureFilter.marks.length -1].value}
          marks={props.slideFeatureFilter.marks}
          valueLabelDisplay="on"
          onChange={handleSliderChange}
          onChangeCommitted={(event, value) => props.featureFiltersChanged(props.slideFeatureFilter.name, value)}
          step={props.slideFeatureFilter.step}
          disabled={!props.activeFeatureFilters[props.slideFeatureFilter.name]}
        />
      }
      { props.assetsNumber > 0 &&
        <span style={{marginLeft: '20px'}}>
          { props.assetsNumber >= 20 &&
            <Tooltip title={'Randomly center on an asset from filter ' + props.slideFeatureFilter.name}>
              <span>
                <IconButton size="small" onClick={() => props.centerOnRandomFeatureForFilter(props.slideFeatureFilter)} disabled={!props.activeFeatureFilters[props.slideFeatureFilter.name]}
                  sx={{
                    color: theme.palette.mode === 'dark' ? commonColors.white: commonColors.black
                  }}>
                  <CasinoIcon/>
                </IconButton>
              </span>
            </Tooltip>
          }
          { props.assetsNumber < 20 &&
            <Tooltip title={'Select all the assets from filter ' + props.slideFeatureFilter.name}>
              <span>
                <IconButton size="small" onClick={() => props.selectFeaturesForFilter(props.slideFeatureFilter)} disabled={!props.activeFeatureFilters[props.slideFeatureFilter.name]}
                  sx={{
                    color: theme.palette.mode === 'dark' ? commonColors.white: commonColors.black
                  }}>
                  <SelectAllICon/>
                </IconButton>
              </span>
            </Tooltip>
          }
        </span>
      }
    </div>
  )
}